import React from 'react';
import {Link} from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { FaWhatsapp } from 'react-icons/fa';

const {FiFacebook,FiTwitter,FiInstagram,FiLinkedin,FiMail,FiPhone,FiMapPin}=FiIcons;

const Footer=()=> {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="space-y-4">
            {/* Dark logo for dark footer background */}
            <img src="https://i.ibb.co/8nzp9Nx6/Tutorhub-Logo-dark.png" alt="Tutor Hub Online" className="h-10 w-auto" />
            <p className="text-gray-300 text-sm">
              Professional assignment support and personalized tutoring to help students achieve academic success worldwide.
            </p>
            <div className="flex space-x-4">
              <SafeIcon icon={FiFacebook} className="w-5 h-5 text-gray-400 hover:text-white cursor-pointer transition-colors" />
              <SafeIcon icon={FiTwitter} className="w-5 h-5 text-gray-400 hover:text-white cursor-pointer transition-colors" />
              <SafeIcon icon={FiInstagram} className="w-5 h-5 text-gray-400 hover:text-white cursor-pointer transition-colors" />
              <SafeIcon icon={FiLinkedin} className="w-5 h-5 text-gray-400 hover:text-white cursor-pointer transition-colors" />
            </div>
          </div>
          
          <div className="space-y-4">
            <h3 className="text-lg font-semibold">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="text-gray-300 hover:text-white transition-colors">Home</Link></li>
              <li><Link to="/about" className="text-gray-300 hover:text-white transition-colors">About Us</Link></li>
              <li><Link to="/assignment-support" className="text-gray-300 hover:text-white transition-colors">Assignment Support</Link></li>
              <li><Link to="/tutoring-services" className="text-gray-300 hover:text-white transition-colors">Tutoring Services</Link></li>
              <li><Link to="/online-exam-help" className="text-gray-300 hover:text-white transition-colors">Online Exam Help US</Link></li>
              <li><Link to="/book-tutor" className="text-gray-300 hover:text-white transition-colors">Book a Tutor</Link></li>
              <li><Link to="/become-tutor" className="text-gray-300 hover:text-white transition-colors">Become a Tutor</Link></li>
            </ul>
          </div>
          
          <div className="space-y-4">
            <h3 className="text-lg font-semibold">Legal</h3>
            <ul className="space-y-2">
              <li><Link to="/terms" className="text-gray-300 hover:text-white transition-colors">Terms & Conditions</Link></li>
              <li><Link to="/privacy-policy" className="text-gray-300 hover:text-white transition-colors">Privacy Policy</Link></li>
              <li><Link to="/faq" className="text-gray-300 hover:text-white transition-colors">FAQ</Link></li>
              <li><Link to="/contact" className="text-gray-300 hover:text-white transition-colors">Contact Us</Link></li>
            </ul>
          </div>
          
          <div className="space-y-4">
            <h3 className="text-lg font-semibold">Contact Info</h3>
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <SafeIcon icon={FiMail} className="w-5 h-5 text-primary" />
                <span className="text-gray-300 text-sm">info@tutorhubonline.com</span>
              </div>
              <a 
                href="https://wa.me/447440373308"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center space-x-3 hover:text-white transition-colors cursor-pointer"
              >
                <SafeIcon icon={FaWhatsapp} className="w-5 h-5 text-green-500" />
                <span className="text-gray-300 text-sm">+44 7440 373308</span>
              </a>
              <div className="flex items-start space-x-3">
                <SafeIcon icon={FiMapPin} className="w-5 h-5 text-primary mt-0.5" />
                <span className="text-gray-300 text-sm">
                  Dubai Silicon Oasis,DDP,<br />
                  Building A1,Dubai,<br />
                  United Arab Emirates
                </span>
              </div>
            </div>
          </div>
        </div>
        
        <div className="mt-8 pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2025 Tutor Hub Online. All rights reserved.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <Link to="/terms" className="text-gray-400 hover:text-white text-sm transition-colors">
              Terms & Conditions
            </Link>
            <Link to="/privacy-policy" className="text-gray-400 hover:text-white text-sm transition-colors">
              Privacy Policy
            </Link>
            <Link to="/faq" className="text-gray-400 hover:text-white text-sm transition-colors">
              FAQ
            </Link>
            <Link to="/contact" className="text-gray-400 hover:text-white text-sm transition-colors">
              Contact Us
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;